import { PageConfig } from "../../router";
import ProviderForm from "../../components/dashboard/provider/ProviderForm";
import { useParams } from "react-router-dom";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Luna - Provider Page",
  description: "Luna - Provider Page",
};

export default function EditProviderPage() {
  const params = useParams();
  const providerId = params.id;
  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="dashboard__main h-100">
        <div className="dashboard__content bg-light-2 h-100 w-100">
          <div className="d-flex flex-column h-100 mb-20 overflow-y-scroll">
            <ProviderForm providerId={providerId} />
          </div>
        </div>
      </div>
    </>
  );
}

export const EditProviderPageConfig: PageConfig = {
  path: "/providers/:id",
  component: EditProviderPage,
  roles: ["admin", "root"],
};
